module.exports = __webpack_public_path__ + "assets/723bcfae8ea4c58c0e1c31dbfd4f3f03.svg";